import validate from 'validate.js';

class Validation {
  isPlateNumber = input => {
    return (
      input.match('^[0-9A-Z]{2}-[0-9A-Z]{2}$') !== null ||
      input.match('^[0-9A-Z]{2}-[0-9A-Z]{3}$') !== null ||
      input.match('^[0-9A-Z]{2}-[0-9A-Z]{4}$') !== null ||
      input.match('^[0-9A-Z]{3}-[0-9A-Z]{2}$') !== null ||
      input.match('^[0-9A-Z]{3}-[0-9A-Z]{3}$') !== null ||
      input.match('^[0-9A-Z]{3}-[0-9A-Z]{4}$') !== null ||
      input.match('^[0-9A-Z]{4}-[0-9A-Z]{2}$') !== null
    );
  };

  isPhoneNumber = input => {
    return input.match('09[0-9]{8}') !== null;
  };

  isEmail = input => {
    const constraints = { from: { email: true } };
    return validate({ from: input }, constraints) === undefined;
  };

  isCreditCardCvc = input => {
    return input.match('[0-9]{3}') !== null;
  };

  isCreditCardPan = input => {
    return input.match('[0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4}') !== null;
  };

  isCreditCardExpireDate = input => {
    return input.match('[0-1]{1}[0-9]{1}/[0-9]{1}[0-9]{1}') !== null;
  };

  isReceiptCarrierCitizenDigitalNumber = input => {
    return input.match('[A-Z]{2}[0-9]{14}') !== null;
  };

  isReceiptB2b = input => {
    return input.match('[0-9]{8}') !== null;
  };
}

export default new Validation();
